import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isNonEmptyStringOrNumber } from '@thesavingsgroup/utils/isNonEmptyStringOrNumber';

import { isInEnum } from '../../../utils/isInEnum';
import { getVehicleApplicationType } from '../../dashboardStore/functions/getVehicleApplicationType';
import { PurchaseType } from '../enums/PurchaseType';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { ToApplyStateFromCanceledApplicationParams } from '../types/ToApplyStateFromCanceledApplicationParams';

export const toApplyStateFromCanceledApplication = async (
  params: ToApplyStateFromCanceledApplicationParams,
): Promise<Partial<ApplyState>> => {
  const {
    params: { vehicle },
    fetchVehicleIdentifiers,
  } = params;
  const { make, model, trim, year } = await fetchVehicleIdentifiers(vehicle);

  const vehicleApplicationType = getVehicleApplicationType(vehicle);

  const isPurchaseType = isInEnum(vehicleApplicationType, PurchaseType);

  const applicationType = isPurchaseType
    ? ApplicationType.PURCHASE
    : vehicleApplicationType;

  const mileage = isNonEmptyStringOrNumber(vehicle.mileage)
    ? String(vehicle.mileage)
    : null;

  const payoffAmount = isNonEmptyStringOrNumber(vehicle.payoffAmount)
    ? String(vehicle.payoffAmount)
    : null;

  const purchasePrice = isNonEmptyStringOrNumber(vehicle.purchasePrice)
    ? String(vehicle.purchasePrice)
    : null;

  const purchaseType = isPurchaseType ? vehicleApplicationType : null;

  let searchVehicle: SearchVehicle;

  if (vehicle.vin) {
    searchVehicle = SearchVehicle.BY_VIN;
  } else if (vehicle.plate && vehicle.province) {
    searchVehicle = SearchVehicle.BY_LICENSE_PLATE;
  } else {
    searchVehicle = SearchVehicle.BY_MAKE_MODEL;
  }

  return {
    applicationType,
    isHydrated: true,
    make,
    mileage,
    model,
    payoffAmount,
    plate: vehicle.plate,
    purchasePrice,
    purchaseType,
    refinanceGoal: vehicle.application.refinanceGoal,
    searchVehicle,
    state: vehicle.province,
    trim,
    vehicleCondition: vehicle.application.vehicleCondition,
    vin: vehicle.vin,
    year: year,
  };
};
